import { render, staticRenderFns } from "./Idioms.vue?vue&type=template&id=5be62bc9&scoped=true&"
import script from "./Idioms.vue?vue&type=script&lang=js&"
export * from "./Idioms.vue?vue&type=script&lang=js&"
import style0 from "./Idioms.vue?vue&type=style&index=0&id=5be62bc9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be62bc9",
  null
  
)

export default component.exports